import { Text } from "components/designV2/text/text";
import styled from "styled-components";

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

export const Description = styled(Text).attrs({
  typography: "b2",
})`
  margin: 0;
`;

export const FooterActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
  width: 100%;
`;
